var exports = {
  "m": "Wrapper__ipodn-",
  "H": "Canvas__h3q164",
};

module.exports = exports;
